import React from 'react';

const AuthError = () => (
  <div>There was an error during authentication. Please login again.</div>
);
export default AuthError;